import { render } from "./StatsModelSelector.vue?vue&type=template&id=3055d91d&scoped=true"
import script from "./StatsModelSelector.vue?vue&type=script&lang=ts"
export * from "./StatsModelSelector.vue?vue&type=script&lang=ts"

import "./StatsModelSelector.vue?vue&type=style&index=0&id=3055d91d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3055d91d"

export default script